// assets
import { AppstoreOutlined } from "@ant-design/icons";
import { CalendarOutlined } from "@ant-design/icons";
import { DatabaseOutlined } from "@ant-design/icons";
import { EnvironmentOutlined } from "@ant-design/icons";
import { PlusOutlined } from "@ant-design/icons";
import { SettingOutlined } from "@ant-design/icons";
import { TeamOutlined } from "@ant-design/icons";
import { UserAddOutlined } from "@ant-design/icons";
import { ApiOutlined } from "@ant-design/icons";
import { ApartmentOutlined } from "@ant-design/icons";
import { HeartOutlined } from "@ant-design/icons";

// types
import { NavItemType } from "types/menu";

const icons = {
  AppstoreOutlined,
  CalendarOutlined,
  DatabaseOutlined,
  EnvironmentOutlined,
  PlusOutlined,
  SettingOutlined,
  TeamOutlined,
  UserAddOutlined,
  ApiOutlined,
  ApartmentOutlined,
  HeartOutlined,
};

// ==============================|| MENU ITEMS - ADMINISTRATION ||============================== //

const administration: NavItemType = {
  id: "administration",
  title: "Administration",
  type: "group",
  children: [
    {
      id: "administration-airport-setup",
      title: "Airport Setup",
      type: "item",
      url: "/administration/airport-setup",
      icon: icons.EnvironmentOutlined,
    },
    {
      id: "administration-airport-graph-builder",
      title: "Airport Graph Builder",
      type: "item",
      url: "/administration/airport-graph-builder",
      icon: icons.ApartmentOutlined,
    },
    {
      id: "administration-airport-travel-times",
      title: "Airport Travel Times",
      type: "item",
      url: "/administration/airport-travel-times",
      icon: icons.EnvironmentOutlined,
    },
    {
      id: "administration-hr-integrations",
      title: "HR Integrations",
      type: "item",
      url: "/administration/hr-integrations",
      icon: icons.ApiOutlined,
    },
    {
      id: "administration-assistance-activities",
      title: "Assistance Activities",
      type: "item",
      url: "/administration/assistance-activities",
      icon: icons.HeartOutlined,
    },
    {
      id: "administration-fixed-schedules",
      title: "Fixed Schedules",
      type: "item",
      url: "/administration/fixed-schedules",
      icon: icons.CalendarOutlined,
    },
    {
      id: "administration-supervisor-performance",
      title: "Supervisor Performance",
      type: "item",
      url: "/administration/supervisor-performance",
      icon: icons.ApiOutlined,
    },
    {
      id: "administration-user-management",
      title: "User Management",
      type: "collapse",
      icon: icons.TeamOutlined,
      children: [
        {
          id: "administration-users-workers",
          title: "Users/Workers",
          type: "item",
          url: "/administration/user-management/users-workers",
          icon: icons.TeamOutlined,
        },
        {
          id: "administration-create-user",
          title: "Create User",
          type: "item",
          url: "/administration/user-management/create-user",
          icon: icons.UserAddOutlined,
        },
        {
          id: "administration-user-availability",
          title: "Availability",
          type: "item",
          url: "/administration/user-management/availability",
          icon: icons.CalendarOutlined,
        },
        {
          id: "administration-admin-setting",
          title: "Admin Setting",
          type: "item",
          url: "/administration/user-management/admin-setting",
          icon: icons.SettingOutlined,
        },
      ],
    },
    {
      id: "administration-assets",
      title: "Assets",
      type: "collapse",
      icon: icons.AppstoreOutlined,
      children: [
        {
          id: "administration-asset-type",
          title: "Asset Category",
          type: "item",
          url: "/administration/assets/type",
          icon: icons.DatabaseOutlined,
        },
        {
          id: "administration-asset-inventory",
          title: "Asset Inventory",
          type: "item",
          url: "/administration/assets/inventory",
          icon: icons.AppstoreOutlined,
        },
        {
          id: "administration-create-asset",
          title: "Create Asset",
          type: "item",
          url: "/administration/assets/create",
          icon: icons.PlusOutlined,
        },
        {
          id: "administration-registered-locations",
          title: "Registered Locations",
          type: "item",
          url: "/administration/assets/registered-locations",
          icon: icons.EnvironmentOutlined,
        },
      ],
    },
    {
      id: "administration-task-settings",
      title: "Task Settings",
      type: "collapse",
      icon: icons.DatabaseOutlined,
      children: [
        {
          id: "administration-task-type",
          title: "Task Type",
          type: "item",
          url: "/administration/task-settings/task-type",
          icon: icons.DatabaseOutlined,
        },
        {
          id: "administration-audit-type",
          title: "Audit Type",
          type: "item",
          url: "/administration/task-settings/audit-type",
          icon: icons.DatabaseOutlined,
        },
        {
          id: "administration-issue-type",
          title: "Issue Type",
          type: "item",
          url: "/administration/task-settings/issue-type",
          icon: icons.DatabaseOutlined,
        },
        {
          id: "administration-task-duration",
          title: "Task Duration",
          type: "item",
          url: "/administration/task-settings/task-duration",
          icon: icons.DatabaseOutlined,
        },
        {
          id: "administration-shift-definition",
          title: "Shift Definition",
          type: "item",
          url: "/administration/task-settings/shift-definition",
          icon: icons.CalendarOutlined,
        },
        {
          id: "administration-work-area",
          title: "Work Area",
          type: "item",
          url: "/administration/task-settings/work-area",
          icon: icons.AppstoreOutlined,
        },
        {
          id: "administration-lines",
          title: "Lines",
          type: "item",
          url: "/administration/task-settings/lines",
          icon: icons.AppstoreOutlined,
        },
        {
          id: "administration-duty-class-setting",
          title: "Duty Class Setting",
          type: "item",
          url: "/administration/task-settings/duty-class-setting",
          icon: icons.DatabaseOutlined,
        },
      ],
    },
    {
      id: "administration-general-setting",
      title: "General Setting",
      type: "collapse",
      icon: icons.SettingOutlined,
      children: [
        {
          id: "administration-ui-config",
          title: "UI Config",
          type: "item",
          url: "/administration/general-setting/ui-config",
          icon: icons.SettingOutlined,
        },
        {
          id: "administration-staff-line-preferences",
          title: "Staff Line Preferences",
          type: "item",
          url: "/administration/general-setting/staff-line-preferences",
          icon: icons.SettingOutlined,
        },
      ],
    },
  ],
};

export default administration;
